import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ESkeletonType } from '@norfolk-southern/accessns-components';

import { PDFPrintGenerator } from '@ruby/configs/common.constants';
import { NSUnitTrainDialogsConstants } from '@ruby/configs/unit-train-dialogs.constants';
import { IUTWaybillDetails } from '@ruby/modules/unit-train/models/unit-train.interface';
import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';

@Component({
  selector: 'ng-waybill-details-dialog',
  styleUrls: ['waybill-details.dialog.scss'],
  templateUrl: 'waybill-details.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaybillDetailsDialog {
  @Input() loading = false;
  @Input() waybill?: IUTWaybillDetails;
  @ViewChild('printContainer') printContainer!: ElementRef;
  skeleton: ESkeletonType = ESkeletonType.WIDGET;
  gridConfigs: IGridConfigurations = NSUnitTrainDialogsConstants.waybillsWBDetailsGridConfigs;

  constructor() {}

  /**
   * Print Waybill
   *
   * @summary Prints the displaying waybill
   * @returns void
   */
  printWaybill(): void {
    PDFPrintGenerator.print('Waybill', this.printContainer.nativeElement.innerHTML);
  }
}
